import { Tooltip } from "antd"

const CustomHover = (props) =>{
  return(
    <>
    {props.value.length> props.limit ?
    <>
    <Tooltip
    title={props.value}
    color={"#CF0000"}>
     <span className="font-roboto text-lg text-[#222222]">
        {props.value.slice(0,props.limit)}...
      </span>
    </Tooltip>
    </>
  :
  <>
  <span className="font-roboto text-lg text-[#222222]">
        {props.value}
      </span>
  </>
  }
    </>
  )
}

export default CustomHover